import { differenceInHours } from 'date-fns'

export default function differenceInHoursDateUtil (start, end) {
  return differenceInHours(start, end)
}
